module.exports = __webpack_public_path__ + "static/media/inappropriate.deec00b0.svg";